
const en = {
  cookieFirst: {
    btnAccept: "ACCEPT",
    btnDeny: "DENY",
    bodyText: "We do NOT use cookies on our website to track customers. There shall be only one cookie regarding this cookie setting. Nevertheless, if you find a cookie from 3rd party provider please drop us a note. You can safely delete this cookie. By clicking “Accept”, you consent to the use of this cookie-setting cookie."
  },
  cookieTracking: {
    btnAccept: "Accept",
    btnDecline: "Decline",
    policyWording: "This website stores cookies on your computer. These cookies are used to improve your website experience and provide more personalized services to you, both on this website and through other media. To find out more about the cookies we use, see our Privacy Policy.",
    cookieDisclaimer: "We won't track your information when you visit our site. But in order to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again."
  },



  homepage: {
    headerTitle1st: "Predict your",
    headerTitle2st: "Market Success",
    headerDescriptionFirst: ["MARKSIM", "provides", "do-it-yourself, easy-to-use, high-end", "market research. Get the insights you need within minutes instead of days."],
    headerDescriptionSecond: [" By combining Cluster Analysis, Market Mapping and Do-it-yourself Conjoint-Analysis, we provide a new methodology to explore the market. Scroll down to learn more or", "contact us."],
    bodyHeader: ["How", "does it work?"],
    bodyHeaderContent: [
      {
        ID: 1,
        NAME: "Sea",
        TITLE: "The Missing Link  ",
        TEXT: "Marksim is bridging the gap between traditional market research and predictive analytics.",
      },
      {
        ID: 2,
        NAME: "Running",
        TITLE: "Market Analyses",
        TEXT: "Visualize your market position, identify your actual competitors and learn how to beat them!",
      },
      {
        ID: 3,
        NAME: "Smiling",
        TITLE: "Buyer Motives",
        TEXT: "Learn why customers are buying your products and let StatShop find an optimal product for you.",
      },
      {
        ID: 4,
        NAME: "Cake",
        TITLE: "Market Share Prediction",
        TEXT: "Make robust predictions about your future market shares easily.",
      },
      {
        ID: 5,
        NAME: "Arrow",
        TITLE: "Marksim Optimizer",
        TEXT: "Don't look back! Look ahead and refine your products and services for the future",
      },
    ],
    bodyFooterContent: ["Do-it-yourself", "Conjoint", "&", "need-based", "Market Segmentation."],
    bodyFooterChoosePlan: ["Choose your", "plan"]
  },

  dropdown: {
    overview: "Overview",
    contact: "Contact",
    imprint: "Imprint"
  },

  footer: {
    contactHeader: ["Know your", "market shares of tomorrow."],
    contactBody: "Contact us:",

    FOOTER_COMPANIES: [
      "Funded by the Austrian Research Promotion Agency",
      "Funded by the Vienna Business Agency 2018",
      "Funded by go-international 2019"
    ],

    contact: "Contact",
    imprint: "Imprint",
    GDPR: "GDPR"
  },

  imprint: {
    header: "Legal Notice",

    article: [
      {
        header: "Copyright",
        content1: "Copyright All content on this site, including, but not limited to text, photos, graphics, logos or button icons and computer code relating thereto or associated therewith, as well as the compilation (meaning the collection, arrangement, and assembly) of all content on this site is the exclusive property of MARKSIM SERVICES GMBH and is protected by copyright laws. Any reproduction, modification, distribution, transmission, republication, display, or performance of the content on this site is strictly prohibited without prior written permission from MARKSIM SERVICES GMBH."
      }
      ,
      {
        header: "Trademarks",
        content1: "MARKSIM is a registered EU-trademark of MARKSIM SERVICES GMBH and must not be used in connection with any product or service without the express written permission of MARKSIM SERVICES GMBH.",
        content2: "Links This site may contain links to other web sites which are not owned or operated by MARKSIM SERVICES GMBH (“Linked Sites”). The Linked Sites are for your convenience only, and you access them at your own risk. MARKSIM SERVICES GMBH is not responsible for the content of the Linked Sites, whether or not MARKSIM SERVICES GMBH is affiliated with sponsors of the sites. MARKSIM SERVICES GMBH does not in any way endorse the Linked Sites. MARKSIM SERVICES GMBH welcomes links to this site. You may establish a hypertext link to this site, provided that the link does not state or imply any sponsorship or endorsement of your site by MARKSIM SERVICES GMBH. You may not use on your site any materials appearing on any MARKSIM SERVICES GMBH site, including but not limited to any logos or characters, without prior written permission from MARKSIM SERVICES GMBH. You may not frame or otherwise incorporate into another web site any of the content or other materials on the MARKSIM SERVICES GMBH site."
      }
      ,
      {
        header: "Use of Site",
        content1: "This site or any portion of this site may not be reproduced, duplicated, copied, sold, resold, or otherwise exploited for any purpose that is not expressly permitted by MARKSIM SERVICES GMBH in duplicate writing. MARKSIM SERVICES GMBH reserves the right to refuse service, terminate accounts, and/or cancel orders in its sole discretion, including, without limitation, if MARKSIM SERVICES GMBH believes that the customers conduct violates applicable law or is harmful to the interests of MARKSIM SERVICES GMBH or its affiliates.",
      }
      ,
      {
        header: "Disclaimer",
        content1: "This site and the materials on this site are provided by MARKSIM SERVICES GMBH on an “As is” basis. MARKSIM SERVICES GMBH makes no representations or warranties of any kind, express or implied, as to the operation of the site or the information, content, materials, or products included on this site. To the full extent permissible by applicable law, MARKSIM SERVICES GMBH disclaims all warranties, express or implied, including, but not limited to, implied warranties of merchantability for a particular purpose. Neither MARKSIM SERVICES GMBH nor any of its affiliates or related entities, nor any person involved in the creation, production, and distribution of this site warrant that the functions contained in the materials will be uninterrupted or error-free, that defects will be corrected, or that MARKSIM SERVICES GMBH or the server that makes it available are free of viruses or other harmful components. The material that you read on this site is provided solely for information and promotional purposes. MARKSIM SERVICES GMBH does not warrant or make any representations regarding the use or the results of the use of the materials in this site in terms of the correctness, accuracy, reliability, or otherwise. You expressly agree that the use of this site is at your sole risk. You (and not MARKSIM SERVICES GMBH) assume the entire cost of all necessary servicing, repair or correction. You expressly agree that neither MARKSIM SERVICES GMBH, nor its affiliated or related entities, nor any of their respective employees, or agents, nor any person or entity involved in the creation, production, and distribution of this site are responsible or liable to any person or entity whatsoever for any loss, damage (whether direct, indirect, incidental, actual, consequential, punitive or otherwise), injury, claim, liability or other cause of any kind or character whatsoever based upon or resulting from the use of this site or any other MARKSIM SERVICES GMBH web site. You expressly acknowledge and agree that MARKSIM SERVICES GMBH is not liable or responsible for any defamatory, offensive or illegal conduct of other subscribers or third parties.",
      }
      ,
      {
        header: "Applicable law and exclusive jurisdiction",
        content1: "This web site is created, controlled and operated by MARKSIM SERVICES GMBH from its headquarters in Vienna, Austria (Europe). MARKSIM SERVICES GMBH makes no representation that materials on this web site are appropriate or available for use in other locations. Those who choose to access this site from other locations do so on their initiative and are responsible for compliance with local laws, if and to the extent local laws are applicable. Terms and conditions of MARKSIM® SaaS",
      }
      ,
      {
        header: "1. Scope of Service",
        content1: "The online tool MARKSIM® is provided to the Business Partner and/or (End-) User by MARKSIM SERVICES GMBH as a SaaS (Statistics as a Service) solution for the project activity."
      }
      ,
      {
        header: "2. Order and Terms of Payment and Cancellation",
        content1: "Orders placed with MARKSIM SERVICES GMBH shall be made in writing. Unless otherwise agreed, MARKSIM SERVICES GMBH is entitled to issue the first partial invoice immediately after the order is placed, for the sum of 50% of the total order amount, with immediate effect. The second partial invoice (50% of the total order amount) is due after the data has been imported and placed online (activation). In the case of late payment, 8% above the base rate of interest shall be agreed upon as default interest. In this case, MARKSIM SERVICES GMBH is entitled to immediately block access to the relevant simulation portal and to rescind the contract. In case of default of payment (over 2 month) all studies and related data shall become the property of MARKSIM. Unless other agreement (like minimum contact period) services may be cancelled by the user at any time. MARKSIM will refund all future prepaid periods, calculated from the month after the cancellation. E.g. if cancellation is received by Oct, 31st we will refund all future periods beginning from December onward. A Cancellation Notice shall be sent the same way the order had been received. E.g. if an order had been received by email, someone shall send its cancellation via email too. If an order had be placed via online-billing, someone shall choose the same way to cancel."
      }
      ,
      {
        header: "3. Maintenance, Data Security and Service Level",
        content1: "Generally, MARKSIM SERVICES GMBH will provide access to the simulation portal 24 hours a day. Notification of routine maintenance will be posted on the marksim.net homepage. Maintenance work can take place daily between the hours of 6 pm and 8 am, and all day on Saturday, Sunday and Public Holidays. Urgent and necessary maintenance work may also be carried out during the day. MARKSIM® operates in certified data processing centers with 24/7 support. Service window may be on Sunday between 8:00PM and Monday 6:00AM CET. MARKSIM SERVICES GMBH is committed to ensuring a service level of 99.9% for its business partners and customers, but cannot provide a guarantee."
      }
    ]
  },

  contact: {
    contactHeader: "Contact",
    contactContent: "Here will be contact information"
  },

  Plans: 
  {

      "plan_description": [
          {"id": "1","description": "Trial Period", "info": "undefined"},
          {"id": "2","description" : "Minimum Term", "info" : "undefined"},
          {"id": "3","description": "Free Period", "info":"undefined"},
          {"id": "4","description":"Billing Period", "info":"undefined"},
          {"id": "5","description":"Import CBC", "info":"Import CBC"},
          {"id": "6","description":"Design CBC", "info":"Design CBC"},
          {"id": "7","description":"HBL", "info":"HBL"},
          {"id": "8","description":"One free Project", "info":"One free Project"},
          {"id": "9","description":"User Licenses", "info":"User Licenses"},
          {"id": "10","description":"Initial setup", "info":"undefined"},
          {"id": "11","description":"Support", "info":"Support"},
          {"id": "12","description":"Create Design Conjoint Analysis (CBC)","info": "Create Design Conjoint Analysis (CBC)"},
          {"id": "13","description":"Use our Limsurvey Conjoint-Modul", "info":"Use our Limsurvey Conjoint-Modul"},
          {"id": "14","description":"Use our Limsurvey questionnaire platform", "info":"undefined"}
      ],

      "plan": [
          {
                  "id": "1",
                  "name": "Basic",
                  "description": "Market Mapping",
                  "provides": [
                      "2 days",
                      "3 months",
                      "1 month",
                      "3 months",
                      "true",
                      "false",
                      "false",
                      "true",
                      "true",
                      "true",
                      "12 months",
                      "true",
                      "true",
                    "true"
                  ],
                  "cost_ones": "€ 690",
          "cost_monthly": "€ 49",
                  "on_sale": ""
          },
          {
              "id":"2",
              "name": "Professional",
              "description": "Market Mapping & Standard Conjoint",
              "provides": [
                  "2 days",
                  "3 months",
                  "1 month",
                  "3 months",
                  "true",
                  "true",
                  "false",
                  "true",
                  "true",
                  "true",
                  "12 months",
                  "true",
                  "true",
                  "true"
              ],
              "cost_ones": "€ 999",
              "cost_monthly": "€ 99",
              "on_sale": ""
          },
          {
              "id":"3",
              "name": "Corporate",
              "description": "Market Mapping & Professional HBL-Conjoint",
              "provides": [
                  "2 days",
                  "3 months",
                  "1 month",
                  "3 months",
                  "true",
                  "true",
                  "true",
                  "true",
                  "true",
                  "true",
                  "12 months",
                  "true",
                  "true",
                  "true"
              ],
              "cost_ones": "€ 2499",
              "cost_monthly": "€ 249",
              "on_sale": ""
          } 
      ],

    "plan_information_text": [
      "START TRIAL",
      "Setup fee" ,
      "month",
      "On Sale - save",
      "View features",
    ]
  }  
};

export default en;
